module.exports = __webpack_public_path__ + "media/images/jobs/jobs_hero_img-4699fc2ce3e4da31a0987f999996ec4e.jpg";